import { proposalsService } from '@/services/proposals';
import type { SendProposalEmailPayload } from '@/services/proposals/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useProposalsSendEmail(proposalId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: SendProposalEmailPayload) => {
      const response = await proposalsService.sendEmail(payload);
      if (!response.success) {
        throw new Error(response.error || 'Erro ao enviar e-mail da proposta');
      }
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['proposal', proposalId, 'email'],
      });
    },
  });
}
